import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { COLOR_BLACK } from "shared/theme/colors";
import { flexColumn, border } from "shared/theme/mixins";

export const StyledAvatarContainer = styled(Box, {
  shouldForwardProp: (propName) => !["bgColor"].includes(propName),
})<{
  bgColor?: string;
}>`
  ${flexColumn({ ai: "center", jc: "center" })};
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: ${({ bgColor }) => bgColor};
  ${border(2, COLOR_BLACK)};
  border-color: rgba(0, 0, 0, 0.08);
`;
